import React from "react";
import { TabProps } from "../../../DestinationModal.types";
import {
    getBaseOverviewContent,
    getDestinationSpecificContent,
} from "../../../DestinationModal.helpers";
import LinkedTrackers from "components/organisms/LinkedTrackers";

const OverviewTab: React.FC<TabProps> = ({
    destination,
    language,
    onClose,
}) => {
    const destinationCode = destination?.destination_type?.code;

    return (
        <div>
            {getBaseOverviewContent({ language, code: destinationCode })}
            {getDestinationSpecificContent(destinationCode, language)}
            <LinkedTrackers
                trackers={destination?.trackers}
                onClose={onClose}
            />
        </div>
    );
};

export default OverviewTab;
